import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EChallanCities from "./component";

const mapStateToProps = ({
    eChallan: {
        cityList,
        isSSR
    }
}) => ({
    cityList,
    isSSR
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EChallanCities);
